import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {useExecuteInView} from '../../../common/useExecuteInView.hook';
import {CategoryType, Maybe, Series} from '../../../graphql/generated/types';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Image} from '../../atoms/Image/Image';
import {Text} from '../../atoms/Text/Text';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';

export interface Props {
  isMobile: boolean;
  relatedSeries: Maybe<Series>;
  onClickGoToRelatedSeries: (e: React.MouseEvent, buttonText: string) => void;
  onInViewRelatedSeries: () => void;
}

export function ViewerEndRelatedSeries({
  isMobile,
  relatedSeries,
  onClickGoToRelatedSeries,
  onInViewRelatedSeries,
}: Props) {
  const ref = useExecuteInView({callback: onInViewRelatedSeries});
  const buttonText =
    relatedSeries?.categoryType === CategoryType.Webtoon
      ? t('viewer_end_go_webtoon_button')
      : t('viewer_end_go_novel_button');
  return (
    <div
      ref={ref}
      className={twMerge(
        'h-72px px-15px pt-15px',
        isMobile && 'bg-theme-bg-surface',
        !isMobile && 'bg-theme-bg-surface-alt px-32px pb-16pxr'
      )}
    >
      <div
        className={twMerge(
          'flex h-56px cursor-pointer items-center overflow-hidden rounded-[8px] bg-theme-solid-100 pl-8px pr-12px'
        )}
        onClick={e => onClickGoToRelatedSeries(e, buttonText)}
      >
        <Image
          src={relatedSeries?.thumbnail}
          ratio={ThumbnailRatio[ThumbnailType.Square]}
          className="box-content h-34px w-34px"
          roundPx={8}
          innerLine={true}
          imageClassName="object-top"
          alt="동일작 보기"
        />
        <Text className="font-small1-bold ml-8px grow text-theme-solid-0">
          {buttonText}
        </Text>
        <Icon type={IconType.ContentHomeArrow02Solid} />
      </div>
    </div>
  );
}
